import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  0% { 
    opacity: 0; 
    transform: translateY(20px) scale(0.95); 
  }
  100% { 
    opacity: 1; 
    transform: translateY(0) scale(1); 
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Content = styled.div`
  background: white;
  padding: 25px 35px;
  border-radius: 10px;
  text-align: center;
  width: 350px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  animation: ${fadeInUp} 0.4s ease-out;

  h2 {
    margin-bottom: 8px;
    color: #005f73;
  }

  p {
    color: #555;
    font-size: 1.1rem;
  }

  button {
    margin-top: 15px;
    background: #005f73;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
`;

export default function SuccessModal({ onClose }) {
  return (
    <Overlay onClick={onClose}>
      <Content onClick={(e) => e.stopPropagation()}>
        <h2>Success!</h2>
        <p>Thank you we’ll be in touch soon.</p>
        <button onClick={onClose}>Close</button>
      </Content>
    </Overlay>
  );
}
